import type { ShopDto, UpdateOneShopNotificationDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopifyPreferenceNotifications(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation("patch", "/shops/{shopId}/preferences/notifications", {
    invalidate: invalidateShop,
    mapVariables: (data: UpdateOneShopNotificationDto) => ({
      params: { path: { shopId: shop.id } },
      body: data,
    }),
  });
}
